import React from 'react'
import {
  Button,
  Grid,
  Typography,
  withStyles
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Page } from 'components'
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ReactGA from "react-ga4";

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100vh',

    gap: 10
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    width: '100%',
    maxWidth: '500px',
    textAlign: 'center',
  },
  code: {
    color: '#D2222D',
  }
})

const VilaDaMonica = (props) => {
    const { classes } = props

  const handleClick = () => {
    ReactGA.event({
      category: "Link Externo",
      action: "open_link_viladamonica",
      label: "VilaDaMonica",
    });

    window.open("https://ingressos.viladamonica.com.br/carrinho/ativarCupom?nrCupom=QUIEROCAFE&byUrl=true", "_blank");
  };

  return (
      <Page title="Campanha Vila da Mônica">
        <Grid container className={[classes.root, classes.flexColumn]}>
        <Grid item className={classes.flexColumn} style={{ margin: 20, gap: 10 }}>
          <Typography variant="h4" style={{ marginBottom: 10, textAlign: 'center', fontWeight: 'bold' }}>
              A Vila da Mônica Gramado está esperando por você!!
            </Typography>

            <Typography className={classes.text}>
              São mais de 20 atrações para se divertir com toda a família. Um lugar repleto de atrações, nossos personagens te esperam com muita aventura, alegria e diversão.
            </Typography>

            <Typography className={classes.text}>
              E cliente App Fidelidade tem um benefício incrível a espera.
            </Typography>

            <Typography className={classes.text}>
              Usando o link abaixo tem um combo promocional em que <b>crianças de 01 a 14 anos são isentas</b> de um ingresso mediante pagante de dois adultos.
            </Typography>

            <Typography className={classes.text}>
              Selecione a data desejada e a opção de ingresso Combo - Criança não paga.
            </Typography>

            <Typography className={classes.text}>
              E tem mais, ingressos adicionais fora do combo tem <b>10% de desconto</b>.
            </Typography>

            <Typography className={classes.text}>
              Válido para compras até 30/11, para utilização até 31/12.
            </Typography>

            <Typography className={classes.text}>
              <b>Clique e confira</b>
            </Typography>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              endIcon={<OpenInNewIcon />}
              onClick={handleClick}
            >
              Ir para o site
            </Button>
          </Grid>

          <Typography variant="caption" className={classes.text} style={{ marginTop: 10 }}>
            *Regras e regulamento no site Vila da Mônica
          </Typography>
        </Grid>
      </Page>
    )
}

VilaDaMonica.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication
  return {
    loggingIn
  }
}
const connectedVilaDaMonicaPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(VilaDaMonica))
)
export { connectedVilaDaMonicaPage as VilaDaMonica }
